import { render, staticRenderFns } from "./IssueRow.vue?vue&type=template&id=398477e1&scoped=true&"
import script from "./IssueRow.vue?vue&type=script&lang=ts&"
export * from "./IssueRow.vue?vue&type=script&lang=ts&"
import style0 from "./IssueRow.vue?vue&type=style&index=0&id=398477e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398477e1",
  null
  
)

export default component.exports